export default {
    id: 'orange-yellow',
    colors: ['#FA5146', '#FFE366'],
};
